import { Bar, BarTick, WrapBar, WrapBarGraph, WrapLine } from "../style/styled";

export function CompBar({ town, syncper_19 }) {
  return (
    <WrapBarGraph>
      <div style={{ width: "100%", height: "25px", textAlign: "center" }}>
        <span>{syncper_19}%</span>
      </div>
      <WrapBar>
        <Bar barHeight={syncper_19}></Bar>
      </WrapBar>
      <BarTick>{town}</BarTick>
      <WrapLine>
        <svg width="200" height="100">
          <line x1="0" x2="200" y1="17" y2="17" stroke="black" />
          <text x="140" y="35">
            전국 평균
          </text>
          <text x="152" y="50">
            82.8%
          </text>
        </svg>
      </WrapLine>
    </WrapBarGraph>
  );
}
